import {ClsMatrizCalculo} from "../cls-matriz";

/** Una fila de `JsonProgSum`: cantidades por insumo y periodo capturadas en el programa. */
export interface IJsonProgSumItem {
  IdCatalogo?: number | string;
  NumeroPeriodo?: number;
  Cantidad?: number;
}


/** Equivalente al detalle persistido por periodo (PuProgramaSum + explosión). */
export interface IProgSumExplosionDetalle extends IJsonProgSumItem  {
  /** Importe a costo directo del periodo (cantidad × costo unitario). */
  Costo?: number;
  /** Importe a precio del periodo (cantidad × precio unitario). */
  Precio?: number;
}

/** DTO de resultado del cálculo de programa de suministros (memoria / IndexedDB / futura API). */
export class ClsDtoResultadoProgSumExplosion {
  IdPresupuesto: string;
  IdPrograma: string;
  FechaUtc: string;
  Detalle: IProgSumExplosionDetalle[];
}

export class ClsMergePptoMatrices {
  IdPresupuestoPartida: bigint;
  Matriz:  ClsMatrizCalculo;
}

export class MergeResult {
  mapEncabezado: Map<bigint, Map<bigint, number>>;
  mapEncabezado2: Map<bigint, Map<number, IProgSumExplosionDetalle>>;
}


